import { createPortal } from 'react-dom'
import { DragOverlay } from '@dnd-kit/core'
import { Table, Column } from '@tanstack/react-table'
import { DataTableRowV2 } from './DataTableBodyV2'
import { DataTableV2DataRow } from '../types'

interface TableDragOverlayV2Props {
  activeId: string | null
  table: Table<DataTableV2DataRow>
  computedColWidths: Record<string, number>
  frozenColOffsetsById: Record<string, number>
  leafColumns: Column<DataTableV2DataRow, unknown>[]
  frozenColumnCount: number
  compactMode: boolean
  isRegrouping: boolean
  cellMeasureRefs?: React.MutableRefObject<Record<string, HTMLDivElement[]>>
}

export function TableDragOverlayV2({
  activeId,
  table,
  computedColWidths,
  frozenColOffsetsById,
  leafColumns,
  frozenColumnCount,
  compactMode,
  isRegrouping,
  cellMeasureRefs,
}: TableDragOverlayV2Props) {
  const activeRow =
    activeId &&
    table.getRowModel().rows.find((r) => {
      const rowData = r.original as DataTableV2DataRow
      return String(rowData?.id || r.id) === activeId
    })

  if (!activeRow) return null

  return createPortal(
    <DragOverlay>
      <div style={{ width: table.getTotalSize() }}>
        <table className="bg-offwhite w-full table-fixed caption-bottom border-separate border-spacing-0 overflow-hidden rounded-l-full rounded-r-full text-sm opacity-70 shadow-lg">
          <colgroup>
            {table.getVisibleLeafColumns().map((column) => (
              <col
                key={column.id}
                style={{
                  minWidth: computedColWidths[column.id] ? `${computedColWidths[column.id]}px` : undefined,
                  width: column.columnDef.size ? `${column.columnDef.size}px` : undefined,
                }}
              />
            ))}
          </colgroup>
          <tbody className="bg-offwhite">
            <DataTableRowV2
              row={activeRow}
              frozenColOffsetsById={frozenColOffsetsById}
              leafColumns={leafColumns}
              freezePane={frozenColumnCount}
              compactMode={compactMode}
              cellMeasureRefs={cellMeasureRefs!}
              isRegrouping={isRegrouping}
              isOverlay
            />
          </tbody>
        </table>
      </div>
    </DragOverlay>,
    document.body
  )
}
